import { useEffect, useRef, useState } from 'react'

import { useGuideTour } from '../provider/guideTourContext'
import {
  hasGuideTourStepTarget,
  isGuideTourForceClickStep,
  isGuideTourStepTargetInteractionBlocked,
} from '../utils/targets'
import * as S from './styles'

export const GUIDE_TOUR_BLOCKED_INTERACTION_FEEDBACK_MS = 550

const stopTargetPointerEvent = (event: React.SyntheticEvent) => {
  event.preventDefault()
  event.stopPropagation()
}

export const GuideTourSpotlightShield = () => {
  const {
    state,
    currentStep,
    targetBounds,
    isCurrentStepReady,
    isInModalLayer,
    notifyBlockedTargetInteraction,
    notifyStepInteraction,
    next,
  } = useGuideTour()
  const [isPulsing, setIsPulsing] = useState(false)
  const pulseTimeoutRef = useRef<number | undefined>(undefined)

  const isActive = state.status === 'active'
  const hasTarget = hasGuideTourStepTarget(currentStep)
  const shouldBlockTargetInteraction =
    isGuideTourStepTargetInteractionBlocked(currentStep)

  useEffect(() => {
    setIsPulsing(false)
  }, [state.activeTourId, state.currentStepIndex])

  useEffect(
    () => () => {
      if (pulseTimeoutRef.current !== undefined) {
        window.clearTimeout(pulseTimeoutRef.current)
      }
    },
    []
  )

  if (
    !isActive ||
    !isCurrentStepReady ||
    !hasTarget ||
    !targetBounds ||
    !shouldBlockTargetInteraction
  ) {
    return null
  }

  const isForceClickStep = isGuideTourForceClickStep(currentStep)

  const handleShieldClick = (event: React.SyntheticEvent) => {
    stopTargetPointerEvent(event)

    if (isForceClickStep) {
      notifyStepInteraction('next')
      next()
      return
    }

    notifyBlockedTargetInteraction()
    setIsPulsing(true)

    if (pulseTimeoutRef.current !== undefined) {
      window.clearTimeout(pulseTimeoutRef.current)
    }

    pulseTimeoutRef.current = window.setTimeout(
      () => setIsPulsing(false),
      GUIDE_TOUR_BLOCKED_INTERACTION_FEEDBACK_MS
    )
  }

  return (
    <S.SpotlightShield
      data-testid="guide-tour-spotlight-shield"
      data-force-click={isForceClickStep ? 'true' : 'false'}
      data-feedback-active={isPulsing ? 'true' : 'false'}
      elevated={isInModalLayer}
      $isPulsing={isPulsing}
      $isForceClick={isForceClickStep}
      aria-hidden
      style={{
        top: targetBounds.top,
        left: targetBounds.left,
        width: targetBounds.width,
        height: targetBounds.height,
      }}
      onClick={handleShieldClick}
      onPointerDown={stopTargetPointerEvent}
    />
  )
}
